import { DateRangeFormat } from '@intentsify/types';
import { DateFormat, formatDate } from './dates';
import { formatDateRange } from './formatDateRange';
var getDate = function (dates) {
    if (!dates) {
        return formatDate({ format: DateFormat.DateMonthDash });
    }
    var start = dates.start, end = dates.end;
    if (start && end) {
        return formatDateRange({ start: start, end: end }, DateRangeFormat.StartEndDateMonthDash);
    }
    if (start) {
        return formatDate({
            date: new Date(start),
            format: DateFormat.DateMonthDash,
        });
    }
    return formatDate({ format: DateFormat.DateMonthDash });
};
export var getExportFileName = function (_a) {
    var prefix = _a.prefix, data = _a.data, dates = _a.dates, _b = _a.extension, extension = _b === void 0 ? '.csv' : _b;
    return "".concat(prefix).concat(!(data === null || data === void 0 ? void 0 : data.id) ? '' : "_".concat(data.id), "_").concat(getDate(dates)).concat(extension ? extension : '');
};
//# sourceMappingURL=getExportFileName.js.map